import { type RouteRecordRaw } from "vue-router";

import {
  APP_PATIENTS_ROUTES as PATIENTS,
  APP_PATIENTS_VIEW_ROUTES as PATIENTS_VIEW,
} from "@/Generated/Routes/paths";

export default [
  {
    ...PATIENTS.root,
    components: { main: () => import("@/Views/patients/index.vue") },
    meta: { sidebar: false },
  },
  {
    path: PATIENTS_VIEW.root.path,
    components: { main: () => import("@/Views/patients/Layouts/PatientView.vue") },
    meta: { sidebar: false },
    children: [
      {
        ...PATIENTS_VIEW.root,
        component: () => import("@/Views/patients/Detail/PersonalData/index.vue"),
      },
      {
        ...PATIENTS_VIEW.info.root,
        component: () => import("@/Views/patients/Detail/PersonalData/index.vue"),
      },
      {
        ...PATIENTS_VIEW.subscription.root,
        component: () => import("@/Views/patients/Detail/Subscription/index.vue"),
      },
      {
        ...PATIENTS_VIEW.clinicalDocumentation.root,
        component: () => import("@/Views/patients/Detail/ClinicalDocumentation/index.vue"),
      },
      {
        ...PATIENTS_VIEW.appointments.root,
        component: () => import("@/Views/patients/Detail/Appointments/index.vue"),
      },
      {
        ...PATIENTS_VIEW.forms.root,
        component: () => import("@/Views/patients/Detail/Forms/index.vue"),
      },
      {
        ...PATIENTS_VIEW.legals.root,
        component: () => import("@/Views/patients/Detail/Legals/index.vue"),
      },
    ],
  },
] as RouteRecordRaw[];
